var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-base"},[_c('div',{staticClass:"section-base__title-box"},[_c('div',{staticClass:"section-base__title"},[_vm._v(" "+_vm._s(_vm.RouteText.NOTIFICATIONS_DOCUMENTS)+" ")])]),_c('NotificationsDocumentsList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }